import React from 'react';
import { createPortal } from 'react-dom';

import type { MediaAttachment } from 'widget/types/attachments';
import { rootStore } from 'widget/stores/RootStore';

import MediaViewerBody from './MediaViewerBody';

export type MediaViewerProps = {
  media: MediaAttachment[];
  initialIndex: number;
  onClose: () => void;
};

const MediaViewer: React.FC<MediaViewerProps> = ({
  media,
  initialIndex,
  onClose
}) => {
  React.useLayoutEffect(() => {
    rootStore.handleMediaViewerOpened();

    return rootStore.handleMediaViewerClosed;
  }, []);

  /**
   * При закрытии сначала уведомляем хост-страницу (iframe уменьшается),
   * затем на следующем кадре размонтируем оверлей.
   * Оверлей (opacity 0.95) скрывает сдвиг контента во время ресайза iframe.
   */
  const handleClose = React.useCallback(() => {
    rootStore.handleMediaViewerClosed();
    requestAnimationFrame(() => {
      onClose();
    });
  }, [onClose]);

  return createPortal(
    <MediaViewerBody
      media={media}
      initialIndex={initialIndex}
      onClose={handleClose}
    />,
    document.body
  );
};

export default React.memo(MediaViewer);
